import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
// Chakra imports
import {
  Box,
  SimpleGrid,
  HStack,
  VStack,
  StackDivider,
  Icon,
  Square,
  Circle,
  Heading,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Stack,
  Button,
  FormControl,
  FormLabel,
  InputGroup,
  InputLeftElement,
  FormErrorMessage,
  Input,
  useColorModeValue,
  useToast,
  useDisclosure,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
// Assets
import {
  FiArrowDown,
  FiChevronRight,
  FiCreditCard,
  FiPlus,
} from "react-icons/fi";
import Pattern from "assets/images/pattern1.png";
import axios from "axios";

export default function Fiat(props) {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const { wallet, user, ...rest } = props;
  const toast = useToast();
  const userState = useSelector((state) => state?.user?.value);
  const token = userState.hasOwnProperty("token") ? userState.token : null;

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading, setLoading] = useState(false);
  const [depositLoading, setDepositLoading] = useState(false);
  const [showDeposit, setShowDeposit] = useState(true);
  const [showCardDeposit, setShowCardDeposit] = useState(false);
  const [cardDepositError, setCardDepositError] = useState(false);
  const [amount, setAmount] = useState(false);

  const borderColor = useColorModeValue("gray.300", "gray.500");
  const textColorSecondary = "gray.400";
  const chevronColor = useColorModeValue("gray.600", "white");

  const deposit = async () => {
    try {
      setDepositLoading(true);
      const { data: response } = await axios.post(
        SERVER_URL + "/wallet/deposit",
        { amount: amount },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.error) {
        toast({
          title: response.error || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
      }
      if (!response.success) {
        toast({
          title: response.message || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
      }
      if (response.success) {
        // redirect to payment link
        window.location.href = response.data.link;
      }
      setDepositLoading(false);
    } catch (error) {
      toast({
        title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
    setDepositLoading(false);
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader> Deposit</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {showDeposit && (
              <Card mb={{ base: "0px", "2xl": "20px" }}>
                <Text color={textColorSecondary} fontSize="md" mb="20px">
                  <b>
                    Money transfered to this account are automatically credited
                    into you account
                  </b>
                </Text>

                <VStack
                  borderWidth={1}
                  borderColor="#cccccc"
                  borderRadius={15}
                  p="5"
                >
                  <Box>
                    <Text> Account Details</Text>
                  </Box>
                  <Box>
                    <Heading size="md"> {wallet.account} </Heading>
                  </Box>
                  <Box>
                    <Text fontSize="18px"> {wallet.chainName} </Text>
                  </Box>
                </VStack>

                <VStack
                  mt="5"
                  divider={<StackDivider borderColor={borderColor} />}
                  spacing={4}
                  align="stretch"
                >
                  <Box
                    w="100%"
                    h="40px"
                    onClick={() => {
                      setShowDeposit(false);
                      setShowCardDeposit(true);
                    }}
                  >
                    <HStack>
                      <Box width="10%">
                        <Circle
                          width="40px"
                          height="40px"
                          background="brand.400"
                        >
                          <Icon
                            as={FiCreditCard}
                            width="20px"
                            height="20px"
                            color="#fff"
                          />
                        </Circle>
                      </Box>
                      <Box width="80%" textAlign="start">
                        {" "}
                        <Text
                          fontSize={{
                            base: "sm",
                            sm: "sm",
                            md: "md",
                            lg: "lg",
                          }}
                          color={textColorSecondary}
                        >
                          {" "}
                          Deposit using Debit Card{" "}
                        </Text>{" "}
                      </Box>

                      <Box width="10%">
                        <Icon
                          as={FiChevronRight}
                          width="20px"
                          height="20px"
                          color={chevronColor}
                        />
                      </Box>
                    </HStack>
                  </Box>

                  {/*
                  <Box w="100%" h="40px">
                    <HStack>
                      <Box width="10%">
                        <Circle
                          width="40px"
                          height="40px"
                          background="brand.400"
                        >
                          <Icon
                            as={FiCreditCard}
                            width="20px"
                            height="20px"
                            color="#fff"
                          />
                        </Circle>
                      </Box>
                      <Box
                        width="80%"
                        textAlign="start"
                        color={textColorSecondary}
                      >
                        {" "}
                        <Text
                          fontSize={{
                            base: "sm",
                            sm: "sm",
                            md: "md",
                            lg: "lg",
                          }}
                        >
                          Deposit using Crypto
                        </Text>{" "}
                        <Text
                          fontSize={{
                            base: "xs",
                            sm: "xs",
                            md: "sm",
                            lg: "sm",
                          }}
                          color="gray.700"
                        >
                          Coming Soon
                        </Text>
                      </Box>
                      <Box width="10%">
                        <Icon
                          as={FiChevronRight}
                          width="20px"
                          height="20px"
                          color={chevronColor}
                        />
                      </Box>
                    </HStack>
                  </Box>
                  */}

                </VStack>
              </Card>
            )}

            {showCardDeposit && (
              <Card mb={{ base: "0px", "2xl": "20px" }}>
                <Text color={textColorSecondary} fontSize="md" mb="20px">
                  <b>
                    Money transfered to this account are automatically credited
                    into you account
                  </b>
                </Text>

                <Stack spacing={4} w={"full"} maxW={"md"} p={3}>
                  <FormControl isInvalid={cardDepositError}>
                    <FormLabel color={textColorSecondary}>Amount</FormLabel>
                    <InputGroup>
                      <InputLeftElement
                        pointerEvents="none"
                        color="gray.300"
                        fontSize="1.2em"
                        children="N"
                      />
                      <Input
                        placeholder="Enter Amount"
                        isInvalid={cardDepositError}
                        errorBorderColor="crimson"
                        onChange={(e) => {
                          setAmount(e.target.value);
                        }}
                      />
                    </InputGroup>
                    {cardDepositError && (
                      <FormErrorMessage>
                        Insufficient balance on card
                      </FormErrorMessage>
                    )}
                  </FormControl>

                  <Button
                    isLoading={depositLoading}
                    bg={"blue.400"}
                    color={"white"}
                    w="full"
                    borderRadius="20"
                    _hover={{
                      bg: "blue.500",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      deposit();
                    }}
                  >
                    Deposit
                  </Button>
                </Stack>

                <VStack
                  mt="5"
                  divider={<StackDivider borderColor={borderColor} />}
                  spacing={4}
                  align="stretch"
                >
                  <Box
                    w="100%"
                    h="40px"
                    onClick={() => {
                      setShowDeposit(true);
                      setShowCardDeposit(false);
                    }}
                  >
                    <HStack>
                      <Box width="10%">
                        <Circle
                          width="40px"
                          height="40px"
                          background="blue.400"
                        >
                          <Icon
                            as={FiCreditCard}
                            width="20px"
                            height="20px"
                            color="#fff"
                          />
                        </Circle>
                      </Box>
                      <Box width="80%" textAlign="start">
                        {" "}
                        <Text
                          fontSize={{
                            base: "sm",
                            sm: "sm",
                            md: "md",
                            lg: "lg",
                          }}
                          color={textColorSecondary}
                        >
                          {" "}
                          Deposit using Transfer{" "}
                        </Text>{" "}
                      </Box>

                      <Box width="10%">
                        <Icon
                          as={FiChevronRight}
                          width="20px"
                          height="20px"
                          color={chevronColor}
                        />
                      </Box>
                    </HStack>
                  </Box>
                </VStack>
              </Card>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>

      <Card
        {...rest}
        align="center"
        p="20px"
        shadow="md"
        background="brand.500"
        backgroundImage={`url(${Pattern})`}
        backgroundPosition="center center"
        backgroundSize="cover"
        backgroundRepeat="no-repeat"
      >
        <HStack spacing="24px">
          <Box w="70%">
            <Text
              color={"white"}
              fontSize="md"
              my={{ base: "auto", "2xl": "10px" }}
              mx="auto"
              fontWeight="ManropeRegular"
              textAlign="start"
            >
              My Balance
            </Text>
            <Text
              color={"white"}
              fontWeight="ManropeSemiBold"
              textAlign="start"
              fontSize="2xl"
              mt={{ base: "5px", "2xl": "5px" }}
            >
              {wallet.currency}{" "}
              {new Intl.NumberFormat("en-US", {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(wallet.balance)}
            </Text>
            {/*<Text
            color={'white'}
            fontSize='md'
            my={{ base: "auto", "2xl": "10px" }}
            mx='auto'
            textAlign='start'>
             USD 20.00
         </Text>*/}
            {/*<Text
            color={textColorPrimary}
            fontSize='md'
            my={{ base: "auto", "2xl": "10px" }}
            mx='auto'
            textAlign='start'>
             0043320734
        </Text>
       */}
          </Box>
          <Box w="30%" h="40px">
            <Square
              size="50px"
              bg="#f4f4f4"
              color="white"
              borderRadius={5}
              onClick={() => {
                if(user.kycStatus!=="completed"){
                  toast({
                    title: "Please verify your identity first",
                    status: "info",
                    duration: 9000,
                    position: "top-right",
                    isClosable: true,
                  });
                }else{
                  onOpen();
                }
              }}
            >
              <Icon as={FiPlus} w="40px" h="40px" color="blue.500" />
            </Square>
          </Box>
        </HStack>

        <SimpleGrid columns={5} mt={2} pt={5}>
          <Link to="/user/transfer">
            <Box>
              <Square size="50px" bg="blue.200" color="white" borderRadius={5}>
                <Icon as={FiArrowDown} w="25px" h="25px" color="#ffffff" />
              </Square>
              <Text
                color={"white"}
                fontSize={{ base: "xs", sm: "sm", md: "sm", lg: "sm" }}
                my={{ base: "auto", "2xl": "10px" }}
                mx="auto"
                textAlign="center"
              >
                Transfer
              </Text>
            </Box>
          </Link>
          <Link to="/user/virtualcard">
            <Box>
              <Square size="50px" bg="blue.400" color="white" borderRadius={5}>
                <Icon as={FiCreditCard} w="25px" h="25px" color="#ffffff" />
              </Square>
              <Text
                color={"white"}
                fontSize={{ base: "xs", sm: "sm", md: "sm", lg: "sm" }}
                my={{ base: "auto", "2xl": "10px" }}
                mx="auto"
                textAlign="center"
              >
                Virtual Card
              </Text>
            </Box>
          </Link>
        </SimpleGrid>
      </Card>
    </>
  );
}
